import useMoney from '../../../hooks/useMoney';
import LangEnum from '../../../lang/LangEnum';
import { TargetUnit } from '../../../services/modules/target/target.types';
import { useTranslation } from '../../translation/TranslationContext';
import { formatAbreviatedTargetValue, formatTargetValue, isMoneyUnit } from '../targetValue.utils';

const useTargetValueFormatter = (unit?: TargetUnit) => {
  const { formatMoney, formatAbreviatedMoney, currencySymbol } = useMoney();
  const { translate, locale } = useTranslation();

  const isMoney = isMoneyUnit(unit);

  const formatValue = (value: string | null) =>
    formatTargetValue({ value, unit, locale, formatMoney });

  const formatAbreviatedValue = (value: string | null) =>
    formatAbreviatedTargetValue({ value, unit, locale, formatAbreviatedMoney });

  const unitSuffix = isMoney ? currencySymbol : translate(LangEnum.GLOBAL_PIECES);

  return { formatValue, formatAbreviatedValue, unitSuffix, isMoney };
};

export default useTargetValueFormatter;
